// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yqSv","title":"styles_title__Hj4oI"};